/**
 * conversation viewer에 전달할 [초안] 배지(draft) 표시 여부를 결정한다.
 *
 * 배경(버그):
 * 답장/전달 발송 시 EmailForm.send()는 발송 직전 forceSave(`helper.save(true, false)`)로
 * 메일을 draft로 저장한 뒤 send()를 호출한다. forceSave 응답이 지연된(UIQueue) setThread
 * 재빌드를 트리거하는데, 그 시점 메일은 아직 draft(isDraft()=true)라 viewer에 draft=true로
 * 전달된다. 이 지연 재빌드가 발송 완료(draft=false) 재빌드보다 나중에 도착하면(last-write-wins)
 * 이미 발송된 메일에 [초안] 배지가 잔존한다.
 *
 * 차단:
 * 발송이 시작된 메일(isSending)은 곧 sent가 되므로, draft 값을 계산하는 단일 지점에서
 * draft=false로 강제해 [초안]으로 그려지지 않게 한다.
 *
 * 이 함수가 반환하는 값이 그대로 EmailInfo.draft → viewer mailInfo.draft → [초안] 배지로
 * 이어진다. 즉 [초안] 표시 여부를 결정하는 단일 지점이다.
 *
 * @param isDraft  메일이 현재 draft 상태인지 (emailObj.isDraft())
 * @param isOutbox outbox 메일인지 (현재 항상 false — outbox 미지원)
 * @param isSending 발송이 시작되어 진행 중인 메일인지 (sendingEmailIds에 등록됨)
 */
export const shouldShowDraftBadge = (
  isDraft: boolean,
  isOutbox: boolean,
  isSending: boolean,
): boolean => (isDraft || isOutbox) && !isSending
